export default {
  setValue (state, payload) {
    state.questions[state.step].value = payload
  },
  startForm (state) {
    state.step = 0
  },
  resetForm  (state) {
    state.step = null
    state.questions = state.questions.map(elem => {
      const value = elem.type === 'checkbox' ? [] : elem.type === 'options' ? null : ''
      return {
        ...elem,
        value
      }
    })
  },
  nextQuestion (state) {
    let step = 1
    if (state.step === 6) {
      if (state.questions[state.step].value === 1) {
        step = 3
      }
    } else if (state.step === 8) {
      if (state.questions[state.step].value === 2) {
        state.questions[12].value = state.questions[12].options.length - 1
        state.questions[14].value = state.questions[14].options.length - 1
        state.questions[15].value = state.questions[15].options.length - 1
        state.questions[16].value = state.questions[16].options.length - 1
        state.questions[17].value = state.questions[17].options.length - 1
        state.questions[27].value = state.questions[27].options.length - 1
      }
    }
    state.step = state.step + step
  },
  previousQuestion (state) {
    state.step = state.step - 1
  }
}
